import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { IconCustomIcon } from './IconCustomIcon';

export const IconCustom = () => (
    <div className='uikit-icons'>
        <Headline headlineType='h3' anchor='customIcons'>
            Custom icons
        </Headline>
        <Playground example={<IconCustomIcon />} />
    </div>
);
